import { Component ,Inject} from '@angular/core';
import { ProfileService } from '../../containers/default-layout/profile.service';
import { CommonService } from '../../common-service/common.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import Swal from 'sweetalert2';
import { LocalStorageService } from '../../common-service/local-storage.service';
import { Utility } from '../../common-service/utility';
import { Router } from '@angular/router';
import { ConfirmPasswordValidator } from './confirm-password.validator';
@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.scss']
})
export class ProfileComponent {
  username:any
  profileFrom:FormGroup
  passwordVisible = true;
  hide = true;
  confirmpasswordVisible = true;
  isLoading:false
  constructor( private _fb: FormBuilder,   private _userService: ProfileService,
    private commonservices: CommonService,
    public dialogRef: MatDialogRef<ProfileComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private _localStorageService: LocalStorageService,
    private router: Router,
    private utility: Utility,
  ) { }

  ngOnInit(): void {
    this._userService.getUserById();

    if(this.data.action=="edit")
      this.getProfile()

    this.profileFrom = this._fb.group({
      'id': ['',Validators.required],
      'user_name': ['',Validators.required],
      'email': ['',Validators.required],
      'mobile_number': ['',Validators.required],
      'password': ['',Validators.required],     
      'confirmPassword': ['',Validators.required],     
      
    },
    {
      validator: ConfirmPasswordValidator("password", "confirmPassword")
    } 
  );
   
  }

  getProfile() {
    this.username = [];
    this._userService.getUserById().then((data: any) => {
      console.log(data);
      
      this.profileFrom.get('id').patchValue(this.data.profileedit.id)
      this.profileFrom.get('user_name').patchValue(this.data.profileedit.user_name)
      this.profileFrom.get('email').patchValue(this.data.profileedit.email)
      this.profileFrom.get('mobile_number').patchValue(this.data.profileedit.mobile_number)

      this.isLoading = false
      this.username = data
      console.log(data);
   
    })  
  }


  Save(){
    this.commonservices.updateProfile(this.profileFrom.value).then((data: any) => {
      
      if (data.success == 1) {
        Swal.fire(data.message, "Profile Update", 'success');
        this.isLoading = false;
        this.dialogRef.close('success')

        this._localStorageService.removeStorage('user_token')
        localStorage.clear()
        this.utility.showSuccess('Logout')
        this.router.navigateByUrl('/auth/login')

      } else {
        Swal.fire(data.message, "warning", 'warning');
        this.isLoading = false;
      }
    })
  }
  close() {
    this.dialogRef.close('success')
  }
}
